/** @module Camunda/ProcessInstanceReport */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query",
	"./_ToolbarSelectMixin",
	"./main"
], function (declare, _, Widget, xml, Query, _ToolbarSelectMixin, Camunda) {
	const FILTER_ALL = "CamundaFilterAllInstance";
	const FILTER_RUNNING = Camunda.STATE_STARTED;
	const FILTER_COMPLETE = Camunda.STATE_COMPLETED;
	const FILTER_CANCELLED = Camunda.STATE_CANCELLED;
	const FILTER_SUSPENDED = Camunda.STATE_SUSPENDED;
	const FILTER_ERROR = Camunda.STATE_ERROR;

	return declare([Widget, _ToolbarSelectMixin], {
		camundaFilterValues: [FILTER_ALL, FILTER_RUNNING, FILTER_COMPLETE, FILTER_CANCELLED, FILTER_SUSPENDED, FILTER_ERROR],

		/**
		 * @override
		 * Add filter parameters
		 */
		onCreateMainQueryLevel: function (ql) {
			const value = this.camundaFilterValue;
			var bFilterAll;
			var state;

			if (value == FILTER_RUNNING) {
				bFilterAll = false;
				state = Camunda.STATE_STARTED;
			} else if (value == FILTER_COMPLETE) {
				bFilterAll = false;
				state = Camunda.STATE_COMPLETED;
			} else if (value == FILTER_CANCELLED) {
				bFilterAll = false;
				state = Camunda.STATE_CANCELLED;
			} else if (value == FILTER_SUSPENDED) {
				bFilterAll = false;
				state = Camunda.STATE_SUSPENDED;
			} else if (value == FILTER_ERROR) {
				bFilterAll = false;
				state = Camunda.STATE_ERROR;
			} else {
				bFilterAll = true;
			}

			ql.serverQuery = !bFilterAll ? new Query().Attr("ActivityState", xml.OP_EQUALS, state) : null;
		}
	});
});
